// extracted by mini-css-extract-plugin
export var image = "style-module--image--be7d3";